import { Directive, ElementRef, EventEmitter, HostListener, Output } from '@angular/core';

@Directive({
  standalone: false,
  selector: '[appNumberOnly]'
})
export class NumberOnlyDirective {
  
  @Output() ngModelChange:EventEmitter<any> = new EventEmitter();

  constructor(private _el: ElementRef) { }

  @HostListener('input', ['$event']) onInputChange(event: any) {
    const initalValue = this._el.nativeElement.value;

    this._el.nativeElement.value = initalValue.replace(/[^0-9]*/g, '');
    if ( initalValue !== this._el.nativeElement.value) {
      event.stopPropagation();
    }
    this.ngModelChange.emit(this._el.nativeElement.value);
  }
}
